import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ManageKeywordsDialog } from '@/pages/preferences/tabs/categories/keywords';
import { PROTECTED, SETTINGS } from '@/lib/constants/routes';
import { useCategoryDetail } from '@/api/category/use-category-detail';

export const Route = createFileRoute(
  '/protected/_layout/settings/_layout/categories/$id/keywords'
)({
  component: KeywordsModal,
});

function KeywordsModal() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: category } = useCategoryDetail(id);
  const { data: parentCategory } = useCategoryDetail(
    category?.parentId ?? undefined
  );

  const handleClose = () => {
    navigate({
      to: `${PROTECTED}${SETTINGS}`,
      search: (old) => ({
        ...old,
        tab: 'category',
        subTab: 'list',
      }),
    });
  };

  if (!category) {
    return null;
  }

  return (
    <ManageKeywordsDialog
      open={true}
      onOpenChange={(open) => !open && handleClose()}
      categoryId={id}
      categoryName={category.name}
      parentName={parentCategory?.name}
    />
  );
}
